import { render, staticRenderFns } from "./boothBook.vue?vue&type=template&id=51c71240&scoped=true&"
import script from "./boothBook.vue?vue&type=script&lang=js&"
export * from "./boothBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c71240",
  null
  
)

export default component.exports